import { render, staticRenderFns } from "./StoreShop.vue?vue&type=template&id=2127f841&"
import script from "./StoreShop.vue?vue&type=script&lang=js&"
export * from "./StoreShop.vue?vue&type=script&lang=js&"
import style0 from "./StoreShop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports